import { ButtonProps, Modal } from "antd"
import React, {ReactNode} from 'react';
// @ts-ignore
import styles from './index.module.scss'

type ComponentProps = {
    title?: string;
    closable?: boolean;
    maskClosable?: boolean;
    mask?: boolean;
    open: boolean;
    children?: ReactNode;
    okText?: string;
    cancelText?:string;
    width?: string|number,
    maxWidth?: number;
    confirmLoading?: boolean;
    footer?: ReactNode;
    getContainer?: string|HTMLElement;
    cancelButtonProps?: ButtonProps;
    okButtonProps?: ButtonProps;
    afterOpenChange?: () => {};
    onOk?: () => {};
    onCancel?: () => {};
}

const PSAIModal = (props: ComponentProps) => {
    const {
        closable = true,
        maskClosable = true,
        // mask = true,
        okText = '确定',
        cancelText = '取消',
        width = "calc(100% - 20px)",
        maxWidth = 800,
        getContainer = '#root'
    } = props

    return (
        <Modal
            title={props.title}
            closable={closable}
            closeIcon={<img src={require('@assets/images/icon_close.png')} />}
            // maskClosable={maskClosable}
            mask={{closable: maskClosable}}
            open={props.open}
            centered
            getContainer={getContainer}
            destroyOnHidden
            className={styles.__pasi_modal}
            width={width}
            style={{maxWidth: maxWidth}}
            confirmLoading={props.confirmLoading}
            footer={props.footer}
            afterOpenChange={props.afterOpenChange}
            onCancel={props.onCancel}
            cancelButtonProps={props.cancelButtonProps}
            cancelText={cancelText}
            okText={okText}
            okButtonProps={props.okButtonProps}
            onOk={props.onOk}
            zIndex={1000}
        >
        {props.children}
        </Modal>
    )
}

// @ts-ignore
PSAIModal.confirm = (params) => {
    const handleClose = () => {
        modal.destroy()
        if (params.onClose) return params.onClose()
        else params.onCancel && params.onCancel()
    }

    const content = (
        <div className={styles.__pasi_confirm_contentwrap}>
            <div className={styles.__pasi_confirm_header}>
                <span>提示</span>
                <button className="ant-modal-close" onClick={handleClose}>
                    <span className="ant-modal-close-x">
                        <img src={require('@assets/images/icon_close.png')} />
                    </span>
                </button>
            </div>
            <div className={styles.__pasi_confirm_body}>
                <div className={styles.__pasi_confirm_title}>{params.title}</div>
                <div className={styles.__pasi_confirm_content}>{params.content}</div>
            </div>
        </div>
    )

    const modal = Modal.confirm({
        className: `${styles.__pasi_modal} ${styles.__pasi_modal_confirm}`,
        style: {maxWidth: 544},
        width: params.width || "auto",
        centered: true,
        icon: null,
        content: content,
        cancelText: params.cancelText,
        okText: params.okText,
        onOk: params.onOk,
        onCancel: params.onCancel,
        getContainer: params.getContainer || document.body,
        // zIndex: 1000,
    })

    return modal
}

// @ts-ignore
PSAIModal.info = (params) => {
    const handleClose = () => {
        modal.destroy()
        if (params.onClose) return params.onClose()
        else params.onCancel && params.onCancel()
    }

    const content = (
        <div className={styles.__pasi_confirm_contentwrap}>
            <div className={styles.__pasi_confirm_header}>
                <span>提示</span>
                <button className="ant-modal-close" onClick={handleClose}>
                    <span className="ant-modal-close-x">
                        <img src={require('@assets/images/icon_close.png')} />
                    </span>
                </button>
            </div>
            <div className={styles.__pasi_confirm_body}>
                <div className={styles.__pasi_confirm_title}>{params.title}</div>
                <div className={styles.__pasi_confirm_content}>{params.content}</div>
            </div>
        </div>
    )

    const modal = Modal.info({
        className: `${styles.__pasi_modal} ${styles.__pasi_modal_confirm}`,
        style: {maxWidth: 544},
        width: params.width || "auto",
        centered: true,
        icon: null,
        content: content,
        cancelText: params.cancelText,
        okText: params.okText,
        onOk: params.onOk,
        onCancel: params.onCancel,
        // zIndex: 1000,
    })

    return modal
}

export default PSAIModal